import type {
  NavigationIconOption,
  NavigationNodeActionId,
  NavigationPermissionOption,
} from '@/types/navigationConfig';

export const navigationIconOptions: NavigationIconOption[] = [
  { value: 'search', labelKey: 'navigationConfig.icons.search' },
  { value: 'notifications', labelKey: 'navigationConfig.icons.notifications' },
  { value: 'timeline', labelKey: 'navigationConfig.icons.timeline' },
  { value: 'description', labelKey: 'navigationConfig.icons.description' },
  { value: 'folder', labelKey: 'navigationConfig.icons.folder' },
  { value: 'apps', labelKey: 'navigationConfig.icons.apps' },
];

export const navigationPermissionOptions: NavigationPermissionOption[] = [
  { value: 'standard-user', labelKey: 'navigationConfig.permissions.standardUser' },
  { value: 'admin', labelKey: 'navigationConfig.permissions.admin' },
  { value: 'analyst', labelKey: 'navigationConfig.permissions.analyst' },
  { value: 'compliance-officer', labelKey: 'navigationConfig.permissions.complianceOfficer' },
];

export const navigationNodeActionDefinitions: Array<{
  id: NavigationNodeActionId;
  labelKey: string;
  permission?: string;
  destructive?: boolean;
}> = [
  { id: 'rename', labelKey: 'navigationConfig.actions.rename', permission: 'MENU_EDIT' },
  { id: 'move', labelKey: 'navigationConfig.actions.move', permission: 'MENU_REORDER' },
  { id: 'duplicate', labelKey: 'navigationConfig.actions.duplicate', permission: 'MENU_CREATE' },
  { id: 'disable', labelKey: 'navigationConfig.actions.disable', permission: 'MENU_EDIT' },
  { id: 'hide', labelKey: 'navigationConfig.actions.hide', permission: 'MENU_EDIT' },
  {
    id: 'assignRoles',
    labelKey: 'navigationConfig.actions.assignRoles',
    permission: 'MENU_ASSIGN_PERMISSION',
  },
  {
    id: 'configureFeatureFlags',
    labelKey: 'navigationConfig.actions.configureFeatureFlags',
    permission: 'MENU_ASSIGN_FEATUREFLAG',
  },
  {
    id: 'configureVisibility',
    labelKey: 'navigationConfig.actions.configureVisibility',
    permission: 'MENU_EDIT',
  },
  { id: 'openProperties', labelKey: 'navigationConfig.actions.openProperties', permission: 'MENU_VIEW' },
  { id: 'delete', labelKey: 'navigationConfig.actions.delete', permission: 'MENU_DELETE', destructive: true },
];

export const navigationOpenModeOptions = [
  { value: 'sameTab', labelKey: 'navigationConfig.openMode.sameTab' },
  { value: 'newTab', labelKey: 'navigationConfig.openMode.newTab' },
] as const;

export const navigationVisibilityOptions = [
  { value: 'visible', labelKey: 'navigationConfig.visibility.visible' },
  { value: 'hidden', labelKey: 'navigationConfig.visibility.hidden' },
  { value: 'disabled', labelKey: 'navigationConfig.visibility.disabled' },
] as const;

export const applicationSelectorWidth = 280;

export const navigationPropertiesWidth = 320;
